import React from "react";
import {BiDownload} from "react-icons/bi";
import {TailSpin} from "react-loader-spinner";

const DownloadAnalysisCSV = (props) => {
  const {isDownloading, onDownload} = props;

  return (
    <div>
      {isDownloading ? (
        <TailSpin
          height="20"
          width="20"
          color="#11cdef"
          ariaLabel="tail-spin-loading"
          radius="1"
        />
      ) : (
        <BiDownload cursor={"pointer"} size="20px" onClick={onDownload} />
      )}
    </div>
  );
};

export default DownloadAnalysisCSV;
